import { Language } from '@coolblue-development/constants';
import { HemingwayLinkType } from '../../types.js';
import { STOREFRONTS_PATHS_FOR_STUDENT_DISCOUNT, STUDENT_DISCOUNT_PATHS } from './urls.js';
function stripLangPrefix(pathname) {
    return pathname.replace(/^\/(nl|en|fr|de)(\/|$)/, '/');
}
export function setStudentDiscountReturnUrl(entrance) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.location)) {
        return;
    }
    const langMatch = window.location.pathname.match(/^\/(nl|en|fr|de)(?=\/|$)/);
    const lang = (_a = langMatch === null || langMatch === void 0 ? void 0 : langMatch[1]) !== null && _a !== void 0 ? _a : Language.DUTCH;
    const pathWithoutLang = stripLangPrefix(window.location.pathname);
    const isRelevantStorefront = ((_b = STOREFRONTS_PATHS_FOR_STUDENT_DISCOUNT[lang]) !== null && _b !== void 0 ? _b : []).some(prefix => pathWithoutLang === prefix);
    if (!isRelevantStorefront)
        return;
    const linksToCheck = [entrance.link, ...((_c = entrance.links) !== null && _c !== void 0 ? _c : [])].filter(Boolean);
    for (const link of linksToCheck) {
        if ((link === null || link === void 0 ? void 0 : link.__typename) !== HemingwayLinkType.External)
            continue;
        const url = new URL(link.absoluteUrl, window.location.origin);
        const pathname = stripLangPrefix(url.pathname);
        if (STUDENT_DISCOUNT_PATHS.includes(pathname)) {
            sessionStorage.setItem('studentDiscountReturnUrl', window.location.href);
            break;
        }
    }
}
//# sourceMappingURL=setStudentDiscountReturnUrl.js.map